import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { STRINGS } from "@/i18n/translations";

const LanguageContext = createContext({ lang: "el", t: (k) => k });

export function detectLang(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "el";
}

export function LanguageProvider({ children }) {
  const { pathname } = useLocation();
  const lang = detectLang(pathname);

  const value = useMemo(() => {
    const t = (key) => {
      const entry = STRINGS[key];
      if (!entry) return key;
      return entry[lang] ?? entry.el ?? key;
    };
    // Resolve a bilingual object {el, en} or plain string.
    const tr = (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.el ?? "";
    };
    return { lang, t, tr };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
